// Create inside a render so changes to jobs, capacity or today's date cannot
// reuse stale results. Callers must treat cached allocations as read-only.
export const memoizeCalendarCalculation = (calculate) => {
  const root = new Map();
  const resultKey = Symbol('result');
  return (...args) => {
    let node = root;
    args.forEach(arg => {
      if (!node.has(arg)) node.set(arg, new Map());
      node = node.get(arg);
    });
    if (!node.has(resultKey)) node.set(resultKey, calculate(...args));
    return node.get(resultKey);
  };
};
